import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=c5c85abc&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=c5c85abc&prod&scoped=true&lang=css"
import style1 from "./SidebarItem.vue?vue&type=style&index=1&id=c5c85abc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c85abc",
  null
  
)

export default component.exports